import React, { useRef, useState } from "react";
import classNames from "classnames";
import SuralinkBrand from "../../../visuals/SuralinkBrand";
import SuralinkLogo from "../../../visuals/SuralinkLogo";

import styles from "./NavHeader.module.scss";

export interface Props {
  // style will be applied to the topmost element
  style?: any;
  // className will be applied to the topmost element
  className?: string;
  /** Name to display on the header. */
  name?: string;
  /** Profile picture URI. Designed to fit a 256x256 image. */
  profilePictureUrl?: string;
}

const NavHeader = ({ style, className, name, profilePictureUrl }: Props) => {
  const menuInputRef = useRef<HTMLInputElement>(null);
  const [menuOpen, openMenu] = useState(false);

  return (
    <div className={classNames(styles.top, className)} style={{ ...style }}>
      <nav className={styles.nav}>
        <a className={styles.logo} href="/">
          <SuralinkLogo />
          <SuralinkBrand />
        </a>
        <a className={styles.link} href="/engagments">
          Engagments
        </a>
        <a className={styles.link} href="/clients">
          Clients
        </a>
        <a className={styles.link} href="/team">
          Team
        </a>
        <a className={styles.link} href="/firm">
          My Firm
        </a>
        <a className={styles.link} href="https://surasend.com">
          Surasend
        </a>
        <a className={styles.link} href="/support">
          Support
        </a>
        <label className={styles.user} htmlFor="user-menu">
          <div className={styles.name}>{name}</div>
          {profilePictureUrl && (
            <img
              className={styles.picture}
              src={profilePictureUrl}
              alt="Profile"
            />
          )}
          <div className={styles.arrows} />
          <input
            readOnly
            onFocus={() => openMenu(true)}
            onBlur={() => openMenu(false)}
            ref={menuInputRef}
            id="user-menu"
          />
          {menuOpen && (
            <div
              className={styles.menu}
              onMouseDown={(e) => e.preventDefault()}
              onClick={(e) => {
                e.stopPropagation();
                if (menuInputRef && menuInputRef.current) {
                  menuInputRef.current.blur();
                }
              }}
              onKeyDown={(e) =>
                e.key === "Enter" &&
                menuInputRef.current &&
                menuInputRef.current.blur()
              }
              role="button"
              tabIndex={0}
            >
              <a className={styles["menu-option"]} href="/">
                Account Settings
              </a>
              <a className={styles["menu-option"]} href="/logout">
                Logout
              </a>
            </div>
          )}
        </label>
      </nav>
      <div className={styles.border} />
    </div>
  );
};

export default NavHeader;
